var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("app-sidebar-key-value-list", { attrs: { rows: _vm.rows } }),
      _vm.item.Description
        ? _c("div", { staticClass: "sidebar-crm-description" }, [
            _vm._v(_vm._s(_vm.item.Description)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }